import { get } from '../server';
import { urls as locationsUrls } from 'Reducers/locations';
import * as urlHelper from 'Helpers/url';
import { getFilledCollection } from 'Reducers/componentHelpers';
import { getType } from 'Reducers/helpers/typeModifier';

const hasData = ({ locations: { collections }}, url) => collections[getType('LOCATIONS', url)];
const _isFetching = ({ locations: { isFetching }}, url) => isFetching[getType('LOCATIONS', url)];
const _isError = ({ locations: { isError }}, url) => isError[getType('LOCATIONS', url)];

export const getLocationPathById = (id, headers = {}) => (dispatch, getState) => {
    const state = getState();
    const url = locationsUrls.getLocationPathById(id);
    const prevData = hasData(state, url);
    const isFetchingData = _isFetching(state, url);
    const hasFailed = _isError(state, url);
    const shouldFetch = !prevData && !isFetchingData && !hasFailed;

    if (shouldFetch) {
        return dispatch(get(locationsUrls.getLocationPathById(id), 'LOCATIONS', {}, headers));
    }

    if (prevData) {
        const data = getFilledCollection('LOCATIONS', state.locations, url);

        return Promise.resolve({ data: { data }});
    }

    return Promise.resolve();
};

export const getLocationPathByLatLon = (params = {}) => (dispatch, getState) => {
    const state = getState();
    const url = `${locationsUrls.getLocationPath}?${urlHelper.paramsToQueryString(params)}`;
    const prevData = hasData(state, url);
    const isFetchingData = _isFetching(state, url);
    const hasFailed = _isError(state, url);
    const shouldFetch = !prevData && !isFetchingData && !hasFailed;

    if (shouldFetch) {
        return dispatch(get(locationsUrls.getLocationPath, 'LOCATIONS', params));
    }

    if (prevData) {
        const data = getFilledCollection('LOCATIONS', state.locations, url);

        return Promise.resolve({ data: { data }});
    }

    return Promise.resolve();
};

export default (data, url) => {
    return {
        type: 'RECEIVE_LOCATIONS',
        data,
        url
    };
};
